const AppContainerMixins = {
  methods: {
    hapticFeedback(style) {
      const message = `haptic-feedback-${style}`
      const messageObj = {
        message,
      }
      const stringifiedMessageObj = JSON.stringify(messageObj)
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.cordova_iab.postMessage(
          stringifiedMessageObj,
        )
      }   
    },
    openPdf(url) {
      console.log('externalpdflink')
      const message = 'pdf-download'
      const messageObj = {
        message,
        content: url,
      }
      const stringifiedMessageObj = JSON.stringify(messageObj)
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.cordova_iab.postMessage(
          stringifiedMessageObj,
        )
      }   
    },
    openLink(url) {
      console.log('externalhtmllink')
      const message = 'html-link'
      const messageObj = {
        message,
        content: url,
      }
      const stringifiedMessageObj = JSON.stringify(messageObj)
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.cordova_iab.postMessage(
          stringifiedMessageObj,
        )
      }
    },
    copyToClipBoard(string) {
      const message = 'copy-to-clipboard'
      const messageObj = {
        message,
        content: string,
      }
      const stringifiedMessageObj = JSON.stringify(messageObj)
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.cordova_iab.postMessage(
          stringifiedMessageObj,
        )
      }
    },
  },
}

export default AppContainerMixins
